var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElement1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2086 27.4898H5.32691C2.89816 27.4898 1.72607 26.366 1.72607 24.046V4.95437C1.72607 2.63437 2.91024 1.51062 5.32691 1.51062H10.2086C12.6373 1.51062 13.8094 2.63437 13.8094 4.95437V24.046C13.8094 26.366 12.6252 27.4898 10.2086 27.4898ZM5.32691 3.32312C3.79232 3.32312 3.53857 3.73395 3.53857 4.95437V24.046C3.53857 25.2665 3.79232 25.6773 5.32691 25.6773H10.2086C11.7432 25.6773 11.9969 25.2665 11.9969 24.046V4.95437C11.9969 3.73395 11.7432 3.32312 10.2086 3.32312H5.32691Z",
    fill: "#232360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1036 16.6148H19.2219C16.7932 16.6148 15.6211 15.491 15.6211 13.171V4.95437C15.6211 2.63437 16.8053 1.51062 19.2219 1.51062H24.1036C26.5323 1.51062 27.7044 2.63437 27.7044 4.95437V13.171C27.7044 15.491 26.5203 16.6148 24.1036 16.6148ZM19.2219 3.32312C17.6873 3.32312 17.4336 3.73395 17.4336 4.95437V13.171C17.4336 14.3915 17.6873 14.8023 19.2219 14.8023H24.1036C25.6382 14.8023 25.8919 14.3915 25.8919 13.171V4.95437C25.8919 3.73395 25.6382 3.32312 24.1036 3.32312H19.2219Z",
    fill: "#232360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1036 27.4893H19.2219C16.7932 27.4893 15.6211 26.3655 15.6211 24.0455V21.8705C15.6211 19.5505 16.8053 18.4268 19.2219 18.4268H24.1036C26.5323 18.4268 27.7044 19.5505 27.7044 21.8705V24.0455C27.7044 26.3655 26.5203 27.4893 24.1036 27.4893ZM19.2219 20.2393C17.6873 20.2393 17.4336 20.6501 17.4336 21.8705V24.0455C17.4336 25.2659 17.6873 25.6768 19.2219 25.6768H24.1036C25.6382 25.6768 25.8919 25.2659 25.8919 24.0455V21.8705C25.8919 20.6501 25.6382 20.2393 24.1036 20.2393H19.2219Z",
    fill: "#232360"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement1);
export default __webpack_public_path__ + "static/media/element-1.527282185c8af7a646a4bd24d04fc9eb.svg";
export { ForwardRef as ReactComponent };